import './QuizQuestion.css';

function MultipleCorrectQuestion({ question, selectedAnswers, onAnswerSelect }) {
    // Ensure selectedAnswers is an array
    const selected = Array.isArray(selectedAnswers) ? selectedAnswers : [];

    const handleChoiceClick = (choiceId) => {
        let newSelected;
        if (selected.includes(choiceId)) {
            // Remove from selection
            newSelected = selected.filter(id => id !== choiceId);
        } else {
            // Add to selection
            newSelected = [...selected, choiceId];
        }
        onAnswerSelect(newSelected);
    };

    return (
        <div className="multiple-correct-question">
            <h2 className="question-text">{question.questionText}</h2>

            <div className="choices-container">
                {question.choices.map((choice) => {
                    const isSelected = selected.includes(choice.id);
                    return (
                        <div
                            key={choice.id}
                            className={`choice-item ${isSelected ? 'selected' : ''}`}
                            onClick={() => handleChoiceClick(choice.id)}
                        >
                            <div className="choice-checkbox">
                                <div className="checkbox-outer">
                                    {isSelected && (
                                        <svg
                                            className="checkbox-check"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="3"
                                        >
                                            <polyline points="20 6 9 17 4 12"></polyline>
                                        </svg>
                                    )}
                                </div>
                            </div>
                            <div className="choice-text">{choice.text}</div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default MultipleCorrectQuestion;
